An opaque cursor to the earlier bounding webhook request.

Resulting webhook requests will _succeed_ this cursor.
